(() => {
  document.addEventListener('click', (event) => {
    for (const nav of document.querySelectorAll('.so-catalog-nav')) {
      if (!nav.contains(event.target)) {
        for (const details of nav.querySelectorAll('details[open]')) details.open = false;
      }
    }
  });
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    const nav = details.closest('.so-catalog-nav');
    if (!nav) return;
    if (window.matchMedia('(min-width: 1001px)').matches) {
      const header = nav.closest('header-component');
      const edge = header?.getBoundingClientRect().bottom ?? nav.getBoundingClientRect().bottom;
      nav.style.setProperty('--so-catalog-top', `${Math.round(edge)}px`);
      const left = Math.max(16, Math.min(details.getBoundingClientRect().left - 20, window.innerWidth - 296));
      details.style.setProperty('--so-catalog-left', `${Math.round(left)}px`);
    }
    for (const other of nav.querySelectorAll('details[open]')) {
      if (other !== details) other.open = false;
    }
  }, true);
  const closeDesktopMenus = () => {
    if (!window.matchMedia('(min-width: 1001px)').matches) return;
    for (const details of document.querySelectorAll('.so-catalog-nav--desktop details[open]')) details.open = false;
  };
  window.addEventListener('resize', closeDesktopMenus);
  window.addEventListener('scroll', closeDesktopMenus, { passive: true });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const nav = event.target.closest?.('.so-catalog-nav');
    if (!nav) return;
    const opened = nav.querySelector('details[open]');
    if (opened) {
      opened.open = false;
      opened.querySelector('summary')?.focus();
      event.stopPropagation();
    }
  });
})();
